//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "SearchForm",
	props: {
		orgList: Array,
		userDistrictId: String,
	},
  data() {
    return {
			searchTerm: "",
			hoveredOrgIndex: null,
			selectedOrg: null, 
    };
  },
	computed: {
		filteredOrgs() {
			if (!!this.searchTerm) return this.orgList.filter(org => org.name.toLowerCase().includes(this.searchTerm.toLowerCase()));
			return [];
		},
	},
	methods: {
		shiftHoveredOrg(dir) {
			// Check for up or down arrow that would go outside of dropdown bounds
			if (this.searchTerm == "") return;
			if (this.hoveredOrgIndex == 0 && dir < 0) return;
			if (dir > 0 && (this.hoveredOrgIndex == 9 || this.hoveredOrgIndex == this.filteredOrgs.length - 1)) return;
			if (this.hoveredOrgIndex == null && dir > 0) this.hoveredOrgIndex = 0;
			else this.hoveredOrgIndex += dir;
		},
		setHoveredOrg(index) {
			this.hoveredOrgIndex = index;
		},
		handleInput(e) {
			this.hoveredOrgIndex = null;
			let val = e.target.value;
			let valIsValidName = this.orgList.some(org => org.name == val);
			if (!valIsValidName) this.selectedOrg = null;
		},
		selectOrg(e, org) {
			if (this.selectedOrg && this.selectedOrg.name == this.searchTerm) {
				if (e && e.code == "Enter") this.$el.querySelector("a.org-search__submit.btn").click();
				return;
			};
			this.selectedOrg = org;
			this.searchTerm = this.selectedOrg.name;
			this.hoveredOrgIndex = null;
		},
		selectDefault(e) {
			if (this.hoveredOrgIndex != null) this.selectOrg(null, this.filteredOrgs[this.hoveredOrgIndex]);
			else if (!!this.filteredOrgs.length) this.selectOrg(e, this.filteredOrgs[0]);
		},
		submitEnterPress(e) {
			if (e.target.matches("[disabled]"))	e.preventDefault();
		}
	},
	created() {
		if (!!this.userDistrictId) {
			let matchingIdOrg = this.orgList.find(org => org.id == this.userDistrictId);
			if (!!matchingIdOrg) this.selectOrg(null, matchingIdOrg);
		}
	}
}
